// extracted by mini-css-extract-plugin
export default {"container":"Error_container__1eCZg","wrapper":"Error_wrapper__Q5x5d","content":"Error_content__nIcpE","image":"Error_image__z+rfb"};